{
  "de": {
    "continueSignIn": {
      "accountSwitch": {
        "title": "Konto wechseln",
        "description": "Dein {provider} Konto ist mit einem anderen fobizz Konto verknüpft. Möchtest du dich jetzt mit diesem Konto neu anmelden?",
        "confirm": "Ja, neu anmelden",
        "cancel": "Abbrechen"
      },
      "linkBlocked": {
        "title": "Konto verknüpfen",
        "description": "Dieses Konto hat bereits eine Verknüpfung mit einem anderen {provider} Konto. Du musst erst in den Einstellungen deine Verknüpfung aufheben und den Prozess neu starten.",
        "confirm": "Zu meinen Einstellungen",
        "cancel": "Abbrechen"
      },
      "linkAvailable": {
        "title": "Konto verknüpfen",
        "description": "Mit diesem fobizz-Konto bist du angemeldet. Möchtest du dein {provider}-Konto damit verknüpfen?",
        "confirm": "Ja, dieses Konto nutzen",
        "otherAccountsTitle": "Weitere fobizz Konten",
        "signIn": "Anderes fobizz Konto nutzen",
        "createNew": "Neues Konto erstellen",
        "cancel": "Abbrechen"
      },
      "anonymous": {
        "title": "{provider}-Anmeldung fortsetzen",
        "description": "Möchtest du ein bestehendes fobizz-Konto verknüpfen oder soll ein neues erstellt werden?",
        "signIn": "Anmelden und verknüpfen",
        "createNew": "Konto mit {provider}-Daten erstellen",
        "cancel": "Abbrechen"
      },
      "providers": {
        "google_oauth2": "Google",
        "microsoft_office365": "Microsoft",
        "apple": "Apple",
        "bildung_lsa": "Bildung-LSA",
        "edulog": "Edulog",
        "edupool": "Edupool",
        "entree": "Entree Federatie",
        "lux": "Lux",
        "untis": "WebUntis",
        "vidis": "VIDIS",
        "univention": "Univention",
        "austria": "Austria"
      },
      "errors": {
        "emailTaken": "Es existiert bereits ein Konto mit dieser E-Mail-Adresse."
      }
    }
  }
}
